import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectIsCompetitorsSavingLoading = createSelector(
  [selectCompetitorsSobState],
  ({ savingStatus }) => savingStatus === RequestStatus.PENDING
)
